export type BallData = { n: string; c?: "warm" | "cool" };
export type BarData = { n: string; v: string; w: number; c: "g" | "a" | "" };
export type DnaData = { k: string; v: string; hi?: boolean };

export interface LotteryInfo {
  key: string;
  title: string;
  vals: string[];
  note: string;
  balls: BallData[];
  resultNote: string;
  bars: BarData[];
  dna: DnaData[];
}

export const lotteryData: Record<string, LotteryInfo> = {
  "mega-sena": {
    key: "mega-sena",
    title: "Mega Sena · Concurso 2820",
    vals: ["1 – 60", "1:50M", "6 nºs", "R$ 6,00", "R$ 35M", "Ter / Qui / Dom"],
    note: 'A soma dos 6 números sorteados cai entre <strong>140 e 240</strong> em 95% dos concursos · Distribuição par/ímpar mais frequente: <strong>3+3</strong> (29%) · Evite sequências óbvias e datas de aniversário',
    balls: [{ n: "04" }, { n: "21" }, { n: "37" }, { n: "42", c: "warm" }, { n: "55" }, { n: "58", c: "cool" }],
    resultNote: "Soma: 217 · 3 pares / 3 ímpares<br/>42 em alta · 58 retornando após 18 ausências",
    bars: [
      { n: "10", v: "58×", w: 92, c: "g" },
      { n: "53", v: "55×", w: 84, c: "g" },
      { n: "42", v: "54×", w: 80, c: "a" },
      { n: "05", v: "51×", w: 75, c: "" },
      { n: "28", v: "19×", w: 28, c: "" },
    ],
    dna: [
      { k: "1 acerto", v: "4.820×" },
      { k: "2 acertos", v: "1.240×" },
      { k: "3 acertos", v: "87×" },
      { k: "4 acertos", v: "12×" },
      { k: "5 acertos", v: "2×", hi: true },
      { k: "6 acertos", v: "0×", hi: true },
    ],
  },
  lotofacil: {
    key: "lotofacil",
    title: "Lotofácil · Concurso 3120",
    vals: ["1 – 25", "1:3,3M", "15 nºs", "R$ 3,50", "R$ 1,5M", "Seg a Sex / Dom"],
    note: 'A soma dos 15 números sorteados cai entre <strong>170 e 225</strong> em 95% dos concursos · Distribuição mais frequente: <strong>8 pares + 7 ímpares</strong> (31%) · Melhor relação custo-benefício entre as loterias da Caixa',
    balls: [{ n: "03" }, { n: "07", c: "warm" }, { n: "11" }, { n: "14" }, { n: "17" }, { n: "19" }, { n: "21" }, { n: "22" }, { n: "23", c: "cool" }, { n: "24" }],
    resultNote: "Soma: 161 · 5 pares / 10 ímpares<br/>07 em alta · 23 retornando após 12 ausências",
    bars: [
      { n: "25", v: "72×", w: 95, c: "g" },
      { n: "20", v: "68×", w: 89, c: "g" },
      { n: "13", v: "63×", w: 82, c: "a" },
      { n: "02", v: "58×", w: 75, c: "" },
      { n: "09", v: "21×", w: 28, c: "" },
    ],
    dna: [
      { k: "10 acertos", v: "8.200×" },
      { k: "11 acertos", v: "2.100×" },
      { k: "12 acertos", v: "340×" },
      { k: "13 acertos", v: "48×" },
      { k: "14 acertos", v: "6×", hi: true },
      { k: "15 acertos", v: "0×", hi: true },
    ],
  },
  quina: {
    key: "quina",
    title: "Quina · Concurso 6450",
    vals: ["1 – 80", "1:24M", "5 nºs", "R$ 3,00", "R$ 4M", "Seg a Sex / Dom"],
    note: 'A soma dos 5 números sorteados cai entre <strong>170 e 250</strong> em 95% dos concursos · Distribuição mais frequente: <strong>3 ímpares + 2 pares</strong> (30%) · Universo amplo de 80 dezenas — distribua bem as escolhas',
    balls: [{ n: "08" }, { n: "23", c: "warm" }, { n: "41" }, { n: "62" }, { n: "77", c: "cool" }],
    resultNote: "Soma: 211 · 2 pares / 3 ímpares<br/>23 em alta · 77 retornando após 22 ausências",
    bars: [
      { n: "04", v: "63×", w: 90, c: "g" },
      { n: "33", v: "59×", w: 84, c: "g" },
      { n: "50", v: "55×", w: 78, c: "a" },
      { n: "71", v: "48×", w: 68, c: "" },
      { n: "12", v: "17×", w: 24, c: "" },
    ],
    dna: [
      { k: "2 acertos", v: "3.600×" },
      { k: "3 acertos", v: "820×" },
      { k: "4 acertos", v: "95×" },
      { k: "5 acertos", v: "8×", hi: true },
    ],
  },
  "dupla-sena": {
    key: "dupla-sena",
    title: "Dupla Sena · Concurso 2580",
    vals: ["1 – 50", "1:15,9M", "6 nºs", "R$ 3,00", "R$ 4M", "Seg / Qua / Sex"],
    note: 'A soma dos 6 números sorteados cai entre <strong>120 e 200</strong> em 95% dos concursos · Distribuição mais frequente: <strong>3+3</strong> (28%) · Dois sorteios por concurso aumentam as chances de prêmio',
    balls: [{ n: "05" }, { n: "18", c: "warm" }, { n: "29" }, { n: "36" }, { n: "44", c: "cool" }, { n: "49" }],
    resultNote: "Soma: 181 · 3 pares / 3 ímpares<br/>18 em alta · 44 retornando após 14 ausências",
    bars: [
      { n: "37", v: "55×", w: 88, c: "g" },
      { n: "44", v: "51×", w: 82, c: "g" },
      { n: "13", v: "47×", w: 75, c: "a" },
      { n: "28", v: "42×", w: 67, c: "" },
      { n: "50", v: "15×", w: 24, c: "" },
    ],
    dna: [
      { k: "2 acertos", v: "2.900×" },
      { k: "3 acertos", v: "580×" },
      { k: "4 acertos", v: "62×" },
      { k: "5 acertos", v: "7×", hi: true },
      { k: "6 acertos", v: "0×", hi: true },
    ],
  },
};

export const lotteryKeys = ["mega-sena", "lotofacil", "quina", "dupla-sena"] as const;
export const lotteryLabels: Record<string, string> = {
  "mega-sena": "Mega Sena",
  lotofacil: "Lotofácil",
  quina: "Quina",
  "dupla-sena": "Dupla Sena",
};

export const features = [
  { num: "I", name: "Histórico", fullName: "Histórico de resultados", desc: "Frequência, atraso, soma e paridade de cada concurso desde o início.", badge: "free" as const },
  { num: "II", name: "Frequência", fullName: "Frequência e atraso", desc: "Quantas vezes cada dezena saiu e há quantos concursos não aparece.", badge: "free" as const },
  { num: "III", name: "Probabilidades", fullName: "Probabilidades explícitas", desc: "Custo versus chance com 6, 7, 8... números. Decisão informada, sempre.", badge: "free" as const },
  { num: "IV", name: "Gerador", fullName: "Gerador aleatório", desc: "Crie jogos aleatórios respeitando o intervalo de cada loteria.", badge: "free" as const },
  { num: "V", name: "Meus jogos", fullName: "Meus jogos salvos", desc: "Salve seus jogos prediletos e mantenha tudo organizado em um só lugar.", badge: "free" as const },
  { num: "VI", name: "Exportar volantes", fullName: "Exportar volantes", desc: "Imprima seus prognósticos ou exporte em PDF e TXT para levar à lotérica.", badge: "free" as const },
  { num: "VII", name: "Alertas", fullName: "Alertas de resultado", desc: "Receba avisos quando seus jogos forem premiados em qualquer concurso.", badge: "free" as const },
  { num: "VIII", name: "Estatísticas", fullName: "Estatísticas avançadas", desc: "Soma, paridade, repetição e padrões reais extraídos de todo o histórico.", badge: "pro" as const },
  { num: "IX", name: "Gerador inteligente", fullName: "Gerador inteligente", desc: "Equilibra pares, ímpares, soma e distribuição. Evita padrões comuns automaticamente.", badge: "pro" as const },
  { num: "X", name: "DNA do jogo", fullName: "DNA do jogo", desc: "Quantas vezes sua aposta acertou 2, 3, 4 ou 5 números em todo o histórico.", badge: "pro" as const },
  { num: "XI", name: "Combinações", fullName: "Combinações e fechamentos", desc: "Gere combinações completas, por duplas, fixas ou fechamentos estratégicos.", badge: "pro" as const },
  { num: "XII", name: "Bolões", fullName: "Bolões otimizados", desc: "Monte grupos, divida cotas e gere combinações com cobertura máxima.", badge: "premium" as const },
  { num: "XIII", name: "Coach IA", fullName: "Coach IA", desc: "Assistente que analisa seus jogos e o histórico recente para responder dúvidas com números reais.", badge: "premium" as const },
  { num: "XIV", name: "Gerador IA", fullName: "Gerador IA personalizado", desc: "Sugere jogos baseados no seu perfil e padrões da loteria — cada um com justificativa.", badge: "premium" as const },
  { num: "XV", name: "Análise IA", fullName: "Análise IA de aposta", desc: "Diagnóstico estatístico de qualquer jogo: forças, fraquezas e sugestões de ajuste.", badge: "premium" as const },
];

export const plans = [
  {
    name: "Básico",
    tier: "free" as const,
    price: "R$ 0",
    period: "/mês",
    items: [
      "Histórico de resultados",
      "Frequência e atraso",
      "Probabilidades explícitas",
      "Gerador aleatório",
      "Meus jogos salvos",
      "Exportação em PDF e TXT",
      "Alertas de resultado",
    ],
    cta: "Criar conta grátis",
    variant: "outline" as const,
    popular: false,
  },
  {
    name: "Pro",
    tier: "pro" as const,
    price: "R$ 14",
    priceSub: ",90/mês",
    items: [
      "Tudo do Básico",
      "Estatísticas avançadas",
      "Gerador inteligente",
      "DNA do jogo",
      "Combinações e fechamentos",
    ],
    cta: "Assinar Pro",
    variant: "default" as const,
    popular: true,
  },
  {
    name: "Premium",
    tier: "premium" as const,
    price: "R$ 24",
    priceSub: ",90/mês",
    items: [
      "Tudo do Pro",
      "Coach IA — chat com seu histórico",
      "Gerador IA personalizado",
      "Análise IA de qualquer jogo",
      "Bolões otimizados + conferidor",
      "Jogos e bolões ilimitados",
    ],
    cta: "Assinar Premium",
    variant: "outline" as const,
    popular: false,
  },
];
